import { Children } from 'react';

import starIconYellow from 'assets/icons/star-make-fill.svg';
import starIcon from 'assets/icons/star-make.svg';

import * as S from './progressStar.styles';
const ProgressStar = ({ progress, makeId }) => {
  // 6178019be776752fc1afa891
  const TOTAL_STAR = 3;
  const achievedStar = progress?.achievedStar || 0;

  return (
    <S.StarsList>
      {Children.toArray(
        Array.from(Array(achievedStar)).map((_) => (
          <li>
            <S.StarImg alt="star" src={starIconYellow} />
          </li>
        ))
      )}
      {Children.toArray(
        Array.from(Array(TOTAL_STAR - achievedStar)).map((_) => (
          <li>
            <S.StarImg alt="star" src={starIcon} />
          </li>
        ))
      )}
    </S.StarsList>
  );
};
export default ProgressStar;
